import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Info ")
const _hoisted_3 = {
  key: 0,
  class: "p-d-flex p-flex-wrap p-gap-2"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"100%"} }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "p-d-flex p-flex-wrap p-gap-2 p-ai-end"
}
const _hoisted_6 = {
  class: "p-field",
  style: {"flex":"0 0 150px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "ID", -1)
const _hoisted_8 = { class: "p-inputtext p-component p-disabled" }
const _hoisted_9 = {
  class: "p-field",
  style: {"flex":"0 0 150px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Rating medio", -1)
const _hoisted_11 = { class: "p-inputtext p-component p-disabled" }
const _hoisted_12 = {
  class: "p-field",
  style: {"flex":"0 0 150px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Numero recensioni", -1)
const _hoisted_14 = { class: "p-inputtext p-component p-disabled" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"100%"} }, null, -1)
const _hoisted_16 = {
  class: "p-field",
  style: {"flex":"0 0 auto","min-width":"200px"}
}
const _hoisted_17 = {
  class: "p-field",
  style: {"flex":"0 0 auto","min-width":"150px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Dati Utente ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-briefcase" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Dati Trasportatore ")
const _hoisted_22 = { class: "p-field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-credit-card" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-key" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Modifica Password ")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("small", { class: "p-mb-2 p-d-block" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }),
  /*#__PURE__*/_createTextVNode(" Compila solo se vuoi modificare la password ")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("input", {
  hidden: "",
  type: "submit"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_VInputSwitch = _resolveComponent("VInputSwitch")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_VInputText = _resolveComponent("VInputText")!
  const _component_CityAutocomplete = _resolveComponent("CityAutocomplete")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_VDropdown = _resolveComponent("VDropdown")!
  const _component_Password = _resolveComponent("Password")!

  return (_openBlock(), _createElementBlock("form", {
    id: "customer-app-form",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createVNode(_component_Fieldset, { class: "p-fluid" }, {
      legend: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_Skeleton, {
                height: "2rem",
                style: {"flex":"0 0 100px"}
              }),
              _hoisted_4,
              _createVNode(_component_Skeleton, {
                height: "2rem",
                style: {"flex":"0 0 200px"}
              }),
              _createVNode(_component_Skeleton, {
                height: "2rem",
                style: {"flex":"0 0 150px"}
              }),
              _createVNode(_component_Skeleton, {
                height: "2rem",
                style: {"flex":"1 1 120px"}
              }),
              _createVNode(_component_Skeleton, {
                height: "2rem",
                style: {"flex":"1 1 120px"}
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.customer?.id || 'N/A'), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.customer?.rating_avg ?? 'N/A'), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.customer?.rating_count ?? 'N/A'), 1)
              ]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_VInputSwitch, {
                  labelOff: "Cliente Standard",
                  labelOn: "Cliente Trasportatore",
                  name: "community_transporter"
                })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_VInputSwitch, {
                  labelOff: _ctx.$t('inactive'),
                  labelOn: _ctx.$t('active'),
                  name: "is_active"
                }, null, 8, ["labelOff", "labelOn"])
              ])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_18,
        _hoisted_19
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_Skeleton, {
                class: "p-mb-2",
                height: "2rem"
              }),
              _createVNode(_component_Skeleton, {
                class: "p-mb-2",
                height: "2rem"
              }),
              _createVNode(_component_Skeleton, {
                class: "p-mb-2",
                height: "2rem"
              }),
              _createVNode(_component_Skeleton, {
                class: "p-mb-2",
                height: "2rem"
              })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.name') + ' *',
                autofocus: "",
                field: "name"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.surname') + ' *',
                field: "surname"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.email') + ' *',
                field: "email",
                type: "email"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: "Telefono",
                field: "phone",
                maxlength: "15"
              })
            ], 64))
      ]),
      _: 1
    }),
    (_ctx.customer?.community_transporter)
      ? (_openBlock(), _createBlock(_component_Fieldset, {
          key: 0,
          class: "p-fluid p-mt-3"
        }, {
          legend: _withCtx(() => [
            _hoisted_20,
            _hoisted_21
          ]),
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(7, (a) => {
                  return _createVNode(_component_Skeleton, {
                    key: `business_${a}`,
                    class: "p-mb-2",
                    height: "2rem"
                  })
                }), 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_VInputText, {
                    label: "Ragione Sociale *",
                    field: "business_name"
                  }),
                  _createVNode(_component_VInputText, {
                    label: "Codice Fiscale *",
                    field: "fiscal_code"
                  }),
                  _createVNode(_component_VInputText, {
                    label: "Indirizzo *",
                    field: "business_address"
                  }),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_FloatLabel, { label: "Città *" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CityAutocomplete, {
                          modelValue: _ctx.businessCity,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.businessCity = $event)),
                          class: _normalizeClass({
                'p-invalid': _ctx.business_city_meta.touched && _ctx.business_city_errors?.length
              })
                        }, null, 8, ["modelValue", "class"])
                      ]),
                      _: 1
                    }),
                    (_ctx.business_city_meta.touched && _ctx.business_city_errors?.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.business_city_errors, (e) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: e,
                            class: "p-error"
                          }, _toDisplayString(_ctx.$t(e)), 1))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_VDropdown, {
                    id: "business_province",
                    label: "Provincia",
                    name: "business_province",
                    options: _ctx.provinces
                  }, null, 8, ["options"]),
                  _createVNode(_component_VInputText, {
                    label: "CAP *",
                    field: "business_postal_code"
                  })
                ], 64))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.customer?.community_transporter)
      ? (_openBlock(), _createBlock(_component_Fieldset, {
          key: 1,
          class: "p-fluid p-mt-3"
        }, {
          legend: _withCtx(() => [
            _hoisted_23,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.banking_info')), 1)
          ]),
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_Skeleton, {
                    class: "p-mb-2",
                    height: "2rem"
                  }),
                  _createVNode(_component_Skeleton, {
                    class: "p-mb-2",
                    height: "2rem"
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_VInputText, {
                    label: "Intestatario IBAN *",
                    field: "iban_holder"
                  }),
                  _createVNode(_component_VInputText, {
                    label: "IBAN *",
                    field: "iban"
                  })
                ], 64))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_24,
        _hoisted_25
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_Skeleton, {
                class: "p-mb-2",
                height: "2rem"
              }),
              _createVNode(_component_Skeleton, {
                class: "p-mb-2",
                height: "2rem"
              })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_26,
              _createVNode(_component_FloatLabel, {
                label: _ctx.$t('user.password')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Password, {
                    modelValue: _ctx.pwd,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pwd = $event)),
                    class: _normalizeClass(_ctx.pwdTouched && _ctx.pwdErrors?.length > 0 ? 'p-invalid' : ''),
                    feedback: false,
                    toggleMask: ""
                  }, null, 8, ["modelValue", "class"])
                ]),
                _: 1
              }, 8, ["label"]),
              (_ctx.pwdTouched && _ctx.pwdErrors?.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.pwdErrors, (e) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: `pwd_${e}`,
                      class: "p-error"
                    }, _toDisplayString(_ctx.$t(e)), 1))
                  }), 128))
                : _createCommentVNode("", true),
              _createVNode(_component_FloatLabel, {
                label: _ctx.$t('user.confirm_password'),
                class: "p-mt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Password, {
                    modelValue: _ctx.cpwd,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.cpwd = $event)),
                    class: _normalizeClass(_ctx.cpwdTouched && _ctx.cpwdErrors?.length > 0 ? 'p-invalid' : ''),
                    feedback: false,
                    toggleMask: ""
                  }, null, 8, ["modelValue", "class"])
                ]),
                _: 1
              }, 8, ["label"]),
              (_ctx.cpwdTouched && _ctx.cpwdErrors?.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.cpwdErrors, (e) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: `cpwd_${e}`,
                      class: "p-error"
                    }, _toDisplayString(_ctx.$t(e)), 1))
                  }), 128))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _: 1
    }),
    _hoisted_27
  ], 32))
}